import { isNil } from 'lodash';
import { IConfigs, useScopedReducer } from 'src/shef-global-state/shefGlobalState';

export const useFeatureFlag = (featureFlagName?: keyof IConfigs) => {
  const { state: configs } = useScopedReducer('configs');
  return isNil(featureFlagName) ? false : Boolean(configs[featureFlagName]);
};
